<template>
  <div class="kye-upload-button" :class="wrapClass">

    <!-- 卡片模式 -->
    <div v-if="mode === 'card'" class="kye-upload-button-card">
      <!-- <upload-load :areaSize="areaSize" v-if="!showCard">
      </upload-load> -->

      <div class="kye-upload-button-card_content" :style="btnStyle" :class="btnClass" @click="handleClick" v-show="showCard">
        <img v-if="!isDisabled" src="../images/plus.png" alt="" />
        <img v-else src="../images/plus-gray.png" alt="" />
      </div>
      <span style="padding-left: 4px" v-if="showLimit">共 {{ uploadLength }} 张，还能上传 {{ limit - uploadLength }} 张</span>
    </div>

    <template v-else-if="mode === 'oldCard'">
      <i class="el-icon-plus"></i>
    </template>

    <!-- 拖拽模式 -->
    <div
      v-else-if="mode === 'drag'"
      class="kye-upload-button-drag"
      :class="btnClass"
      :style="btnStyle"
      ref="buttonArea"
      @dragenter="onDragenter"
      @dragleave="onDragleave"
      @drop.prevent="onDrop">
      <template v-if="!$slots.upload">
        <div class="kye-upload-button-drag_head">
          <img src="../images/file.png" alt="" />
          <div class="kye-upload-button-drag_tips">
            <p class="kye-upload-button-drag_tips-title">{{ title }}</p>
            <p class="kye-upload-button-drag_tips-sub-title" v-if="tips">{{ tips }}</p>
          </div>
        </div>
        <kye-button
          class="kye-upload-button-drag_button"
          :disabled="isDisabled"
          :auth="auth"
          :type="type"
          :icon="icon">{{ text }}<span style="padding-left: 4px" v-if="showLimit">({{ fileList.length }}/{{ limit }})</span>
        </kye-button>
      </template>
      <template v-else>
        <slot name="upload" />
      </template>

      <div class="kye-upload-button-drag_dragover" v-show="isDragover && !btnLoading">
        <img src="../images/plus-dragover.png" alt="" />
        <span>拖拽到这里</span>
      </div>

      <div class="kye-upload-button-drag_loading" v-show="btnLoading">
        <i class="el-icon-loading"></i>
        <span>{{ loadingText }}</span>
      </div>
    </div>

    <!-- 按钮模式 -->
    <kye-button
      v-else
      :disabled="isDisabled"
      :loading="btnLoading"
      :auth="auth"
      :round="round"
      :type="type"
      :icon="icon">{{ btnLoading ? loadingText : text }}<span style="padding-left: 4px" v-if="showLimit">({{ fileList.length }}/{{ limit }})</span>
    </kye-button>
  </div>
</template>

<script>
  // import UploadLoad from './upload-load.vue'

  export default {
    components: {
      // UploadLoad
    },
    props: {
      loading: Boolean,
      disabled: Boolean,
      mode: {
        type: String,
        default: 'button'
      },
      auth: String,
      type: String,
      icon: String,
      text: String,
      round: Boolean,
      loadingText: String,
      title: String,
      tips: String,
      limit: Number,
      showLimit: Boolean,
      fileList: Array,
      uploadList: Array,
      areaSize: [Number, String, Array], // 宽*高
    },
    data () {
      return {
        btnLoading: false,
        isDragover: false,
      }
    },
    computed: {
      isDisabled () {
        const { mode } = this.$props
        // 上传中无需改成禁用样式，只需禁用上传即可（isDisabled包含上传禁用）
        if (this.btnLoading && mode !== 'card') {
          return false
        }
        return this.$props.disabled
      },
      uploadLength () {
        const { fileList = [], uploadList = [] } = this.$props
         return fileList.length + uploadList.length
      },
      showCard () {
        const { limit } = this.$props
        if (limit) {
          return this.uploadLength < limit
        }
        return true
      },
      // isLimit () {
      //   const { limit } = this.$props
      //   if (limit) {
      //     return true
      //   }
      //   return false
      // },
      isFullWidth () {
        const { areaSize, mode } = this.$props
        if (mode !== 'drag') {
          return false
        }
        if (areaSize === '100%') {
          return true
        }
        if (Array.isArray(areaSize) && areaSize[0] === '100%') {
          return true
        }
        return false
      },
      btnStyle () {
        const { mode } = this.$props
        const defaultSize = mode === 'drag' ? [320, 128] : 148
        let s = this.$props.areaSize || defaultSize
        if (!Array.isArray(s)) {
          s = [s, s]
        }
        return {
          'width': this.isFullWidth ? '100%' : parseInt(s[0]) + 'px',
          'height': parseInt(s[1]) + 'px',
        }
      },
      wrapClass () {
        return {
          'is-old-card': this.$props.mode === 'oldCard',
          // 'is-disabled': this.isDisabled
        }
      },
      btnClass () {
        const { mode } = this.$props
        return {
          'is-disabled': this.isDisabled,
          'is-dragover': this.isDragover,
          'is-loading': mode === 'drag' && this.btnLoading,
          'is-slot': mode === 'drag' && this.$slots.upload && !this.isDragover && !this.btnLoading
        }
      },
    },
    watch: {
      loading (val) {
        const { mode } = this.$props
        if (mode === 'oldCard') {
          return
        }
        this.btnLoading = val
      }
    },
    methods: {
      handleClick () {
        if (this.isDisabled) return
        this.$emit('upload')
      },
      onDragenter (e) {
        if (this.isDisabled) return
        this.isDragover = true
      },
      onDragleave (e) {
        if (!this.$refs.buttonArea.contains(e.relatedTarget)) {
          this.isDragover = false
        }
      },
      onDrop () {
        this.isDragover = false
      }
    }
  }
</script>

<style lang="scss">
  .kye-upload-button {
    &-card {
      // width: 148px;
      // height: 148px;
      display: flex;
      align-items: center;
      justify-content: center;
      &_content {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--g-bg-gray);
        border: 2px dashed var(--g-border-color);
        border-radius: var(--g-border-radius);
        cursor: pointer;
        img {
          width: 16px;
        }
        &:hover {
          border-color: var(--g-color-primary-hover);
          background: var(--g-bg-primary-hover);
        }
        &:active {
          border-color: var(--g-color-primary-active);
          background: var(--g-bg-primary-active);
        }
        &.is-disabled {
          border-color: var(--g-border-color);
          background-color: var(--g-bg-gray);
          cursor: not-allowed;
        }
      }
    }

    &.is-old-card {
      i {
        color: #9D9CA4;
      }
      &.is-disabled {
        i {
          color: #D8D7DC;
        }
      }
    }

    &-drag {
      width: 380px;
      height: 128px;
      border: 2px dashed var(--g-border-color);
      border-radius: var(--g-border-radius);
      &:not(.is-slot) {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 24px;
        box-sizing: border-box;
      }
      // overflow: hidden;
      &_head {
        display: flex;
        align-items: center;
        justify-self: center;
        img {
          width: 40px;
          margin-right: 8px;
        }
      }
      &_tips {
        text-align: left;
        &-title {
          font-size: 12px;
          font-weight: bold;
          line-height: 16px;
          color: var(--g-color-text);
        }
        &-sub-title {
          font-size: 12px;
          color: #6E6B75;
          height: 18px;
          margin-top: 2px;
        }
      }
      &_button {
        margin-top: 12px;
      }
      &_dragover {
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        img {
          width: 14px;
        }
        span {
          font-size: 14px;
          color: var(--g-color-primary);
        }
      }
      &_loading {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        .el-icon-loading {
          font-size: 26px;
          color: var(--g-color-primary);
        }
        span {
          font-size: 14px;
          color: #575561;
          margin-left: 4px;
        }
      }
      &:hover {
        border-color: var(--g-color-primary);
      }
      &.is-dragover {
        background: var(--g-bg-primary);
        border-color: var(--g-color-primary);
        > :not(.kye-upload-button-drag_dragover) {
          display: none !important;
        }
      }
      &.is-loading {
        cursor: not-allowed;
        border-color: var(--g-border-color);
        > :not(.kye-upload-button-drag_loading) {
          display: none !important;
        }
      }
      &.is-disabled {
        cursor: not-allowed;
        border-color: var(--g-border-color);
        background-color: var(--g-input-disabled-bg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-upload/components/upload-button.vue